export const AMENITY_CATEGORIES = [
	{
		heading: "Storage Unit Amenities",
		items: [
			{
				label: "24 Hour Storage Units",
				slug: "twenty-four-hour-access-storage-units"
			},
			{
				label: "Climate Controlled Storage Units",
				slug: "climate-control-storage-units"
			},
			{ label: "Drive Up Storage Units", slug: "drive-up-storage-units" },
			{
				label: "Storage Units with Electricity",
				slug: "storage-units-with-electricity"
			},
			{ label: "Wine Storage Units", slug: "wine-storage-units" }
		]
	},
	{
		heading: "Storage Unit Sizes",
		items: [
			{ label: "Mini Storage Units", slug: "mini-storage-units" },
			{ label: "5x5 Storage Units", slug: "5x5-storage-units" },
			{ label: "5x10 Storage Units", slug: "5x10-storage-units" },
			{ label: "5x15 Storage Units", slug: "5x15-storage-units" },
			{ label: "10x10 Storage Units", slug: "10x10-storage-units" },
			{ label: "10x15 Storage Units", slug: "10x15-storage-units" },
			{ label: "10x20 Storage Units", slug: "10x20-storage-units" },
			{ label: "10x25 Storage Units", slug: "10x25-storage-units" },
			{ label: "10x30 Storage Units", slug: "10x30-storage-units" },
			{ label: "Storage Lockers", slug: "storage-lockers" }
		]
	},
	{
		heading: "Vehicle Storage Units",
		items: [
			{ label: "Boat Storage Units", slug: "boat-storage-units" },
			{ label: "Car Storage Units", slug: "car-storage-units" },
			{ label: "RV Storage Units", slug: "rv-storage-units" },
			{
				label: "Motorcycle Storage Units",
				slug: "motorcycle-storage-units"
			}
		]
	}
];

export const STATE_TITLE_TEMPLATE = (stateName) =>
	`Find Storage Units in ${stateName} | Storage.com`;

export const STATE_DESCRIPTION_TEMPLATE = (stateName) =>
	`Locate popular storage unit types across ${stateName}. Browse by city, compare storage types, and find the right solution for your needs.`;
